//-- Copyright (c) 2021 TMT Insights Group, LLC

export const SortOrder = {
  Ascending: 'asc',
  Descending: 'desc'
};

export function getNextSortOrder(sortOrder) {
  switch (sortOrder) {
    case SortOrder.Ascending:
      return SortOrder.Descending;
    case SortOrder.Descending:
      return SortOrder.Ascending;
  }
}
